export default (state = { isMobile: false, height: 0, width: 0 }, action) => {
  switch (action.type) {
    case "SET_ISMOBILE":
      return Object.assign({}, state, {
        isMobile: action.isMobile,
      });
      break;
    default:
      return state;
  }
};
